module.exports = __webpack_public_path__ + "img/petroleum.12493a7a.jpg";